import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SHOW_LEGACY_TOOLS } from '../config/features';

const Header = ({ isConnected, orgInfo, onDisconnect }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <header className="app-header">
      <div className="header-wrapper">
        <div className="header-top">
          <div className="logo-section">
            <h1 className="app-title">
              <span className="force-text">Force</span>
              <span className="sight-text">Sight</span>
            </h1>
            <p className="app-tagline">The context engine for your Salesforce org</p>
          </div>
        </div>
        
        {isConnected && orgInfo && (
          <div className="header-bottom">
            <nav className="header-nav">
              {SHOW_LEGACY_TOOLS && (
                <button
                  className={`nav-tab ${location.pathname === '/dashboard' ? 'active' : ''}`}
                  onClick={() => navigate('/dashboard')}
                  title="Compare profiles and permission sets side by side"
                >
                  Permissions
                </button>
              )}
              <button
                className={`nav-tab ${location.pathname === '/documentation' ? 'active' : ''}`}
                onClick={() => navigate('/documentation')}
                title="Catalog and document your org's objects and fields with AI"
              >
                Documentation
              </button>
              {SHOW_LEGACY_TOOLS && (
                <button
                  className={`nav-tab ${location.pathname === '/deployments' ? 'active' : ''}`}
                  onClick={() => navigate('/deployments')}
                  title="Check permissions for recently deployed components"
                >
                  Deploy Review
                </button>
              )}
            </nav>
            <div className="connection-info">
              <div className="org-details">
                <span className="org-name">{orgInfo.orgName}</span>
                <span className="user-info">{orgInfo.username}</span>
              </div>
              <button
                onClick={onDisconnect}
                className="disconnect-btn"
                title="Disconnect from Salesforce"
              >
                🔌 Disconnect
              </button>
            </div>
          </div>
        )}
      </div>
      
      <style jsx>{`
        .app-header {
          background: rgba(0, 0, 0, 0.8);
          border-bottom: 2px solid var(--force-cyan);
          padding: 1rem 2rem 0.5rem;
          box-shadow: 0 2px 10px rgba(0, 212, 255, 0.3);
        }
        
        .header-wrapper {
          max-width: 1400px;
          margin: 0 auto;
        }
        
        .header-top {
          display: flex;
          justify-content: flex-start;
        }
        
        .header-bottom {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 1.5rem;
          margin-top: 0.5rem;
          padding-bottom: 0.5rem;
        }

        .header-nav {
          display: flex;
          gap: 0.25rem;
        }

        .nav-tab {
          background: transparent;
          border: none;
          color: var(--gray-400);
          padding: 0.4rem 1rem;
          border-radius: 6px;
          cursor: pointer;
          font-size: 0.85rem;
          font-family: var(--font-body);
          transition: all 0.2s;
        }

        .nav-tab:hover {
          color: var(--force-cyan);
          background: rgba(0, 212, 255, 0.08);
        }

        .nav-tab.active {
          color: var(--force-cyan);
          background: rgba(0, 212, 255, 0.15);
          font-weight: bold;
        }
        
        .logo-section {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        
        .app-title {
          font-family: var(--font-display);
          font-size: 2rem;
          font-weight: 700;
          margin: 0;
          letter-spacing: -0.02em;
        }
        
        .force-text {
          color: var(--jedi-blue);
        }
        
        .sight-text {
          color: var(--force-cyan);
        }
        
        .app-tagline {
          font-family: var(--font-body);
          font-size: 0.9rem;
          color: var(--gray-400);
          margin: 0;
        }
        
        .connection-info {
          display: flex;
          align-items: center;
          gap: 1.5rem;
          background: rgba(0, 0, 0, 0.3);
          padding: 0.5rem 1.5rem;
          border-radius: 8px;
          border: 1px solid rgba(0, 212, 255, 0.2);
        }
        
        .org-details {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: var(--star-white);
        }
        
        .org-name {
          font-weight: bold;
          color: var(--yoda-green);
          font-size: 1rem;
        }
        
        .user-info {
          font-size: 0.85rem;
          color: var(--gray-400);
        }
        
        .disconnect-btn {
          background: var(--sith-red);
          color: var(--star-white);
          border: none;
          padding: 0.4rem 0.8rem;
          border-radius: 4px;
          cursor: pointer;
          font-size: 0.85rem;
          transition: all 0.2s;
          white-space: nowrap;
        }
        
        .disconnect-btn:hover {
          background: #ff0000;
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(255, 0, 0, 0.3);
        }
        
        @media (max-width: 768px) {
          .header-top {
            padding-right: 0;
          }
          
          .app-title {
            font-size: 2rem;
          }
          
          .connection-info {
            flex-direction: column;
            gap: 0.8rem;
            padding: 0.8rem;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;